import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './plugins/element.js'
import '@/assets/css/glober.css'
import '@/assets/font/iconfont.css'
import format from 'vue-text-format';
// import { Message } from 'element-ui';
// 导入全局静态变量
import Static from "@/common/static.vue"

//引入axios模块
import axios from 'axios'
// axios.interceptors.request.use(config => {
//   // 为请求头添加Authorization字段为服务端返回的token
//   config.headers.Authorization = window.sessionStorage.getItem('token')
//   // return config是固定用法 必须有返回值
//   return config
// })

// axios.interceptors.response.use(res => {
//   // 为请求头添加Authorization字段为服务端返回的token
//   // console.log(res)
//   // console.log(router.history.current.path)
//   if (!res.data) {
//     if (router.history.current.path != "/login") {
//       Message.error("登录过期，请重新登录")
//       router.push("/login")
//       return
//     }

//   }
//   // return config是固定用法 必须有返回值
//   return res
// })

Vue.prototype.$axios = axios
Vue.prototype.$static = Static

Vue.prototype.bigImg = (url) => {
  window.open(url)
}

//创建方法监听sessionStorage的全局方法
Vue.prototype.resetSetItem = function (key, newVal) {
  if (key === "keyWords") {
    var newStorageEvent = document.createEvent('StorageEvent');
    const storage = {
      setItem: function (k, val) {
        sessionStorage.setItem(k, val);

        newStorageEvent.initStorageEvent('setItem', false, false, k, null, val, null, null);

        window.dispatchEvent(newStorageEvent)
      }
    }
    return storage.setItem(key, newVal);
  }

}

//全局时间过滤器
Vue.filter("dateFormat", (date) => {

  let obj = {}
  obj.h = parseInt(date / 3600);
  obj.f = parseInt((date - obj.h * 3600) / 60);
  obj.m = parseInt(date - obj.h * 3600 - obj.f * 60);

  if (obj.h < 10) { obj.h = '0' + obj.h }
  if (obj.f < 10) { obj.f = '0' + obj.f }
  if (obj.m < 10) { obj.m = '0' + obj.m }


  return `${obj.h}:${obj.f}:${obj.m}`
})
//全局时间过滤器
Vue.filter("mf", (date) => {

  let obj = {}
  obj.h = parseInt(date / 3600);
  obj.f = parseInt((date - obj.h * 3600) / 60);
  obj.m = parseInt(date - obj.h * 3600 - obj.f * 60);

  // if (obj.h < 10) { obj.h = '0' + obj.h }
  // if (obj.f < 10) { obj.f = '0' + obj.f }
  if (obj.m < 10) { obj.m = '0' + obj.m }
  if (obj.h > 0) {
    return `${obj.h}小时${obj.f}分${obj.m}秒`
  } else {
    return `${obj.f}分${obj.m}秒`

  }
})

Vue.use(format);

// Vue.filter("formatMonenyNumber", (number) => {
//   if (!number) return;
//   let str = [];
//   if (typeof number === "number") {
//     number = String(number);
//   }
//   if (number.length <= 3) {
//     return number;
//   }
//   String(number)
//     .split("")
//     .reverse()
//     .forEach((item, index) => {
//       if (index != 0 && index % 3 == 0) {
//         str.push(",", item);
//       } else {
//         str.push(item);
//       }
//     });
//   return str.reverse().join("");
// }),

  Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
